import React from "react";
import { Draggable } from "react-beautiful-dnd";
export default function PRCTeam({ team, index, disable, onMove, count }) {
  return <Draggable draggableId={team[0]} index={index} isDragDisabled={disable}>
    {provided => <div {...provided.draggableProps} ref={provided.innerRef} className="ranking-list-item">
      <span {...provided.dragHandleProps} className="drag-grip" aria-label={"Drag " + team[1]}>⠿</span>
      <span className="rank-position">{index + 1}</span>
      <span className="team-name">{team[1]}</span>
      <span className="team-record">{team[3][0]}–{team[3][1]}</span>
      <span className="ranking-controls"><button type="button" disabled={disable || index === 0} onClick={() => onMove(index, -1)} aria-label={"Move " + team[1] + " up"}>↑</button><button type="button" disabled={disable || index === count - 1} onClick={() => onMove(index, 1)} aria-label={"Move " + team[1] + " down"}>↓</button></span>
    </div>}
  </Draggable>;
}
